import { getPianoCookieClient } from 'utils/getPianoCookieClient';
import { getSubscriptionName } from 'utils/getSubscriptionName';

export const useIsOutsideDigitalUser = () => {
  const pianoUser = getPianoCookieClient();

  if (!pianoUser?.roles) return null;

  return getSubscriptionName(pianoUser?.roles) === 'outside_digital';
};
